export function deviceSupportsApplePay(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    ('ApplePaySession' in window)
    && Boolean(ApplePaySession?.supportsVersion?.(3))
    && Boolean(ApplePaySession?.canMakePayments?.())
  );
}
